import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export default function Landing() {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const totalItems = 5; // number of commentSection cards
  const intervalRef = useRef(null);

  const testimonials = [
    {
      name: "Jackline Fare",
      avatar: "/assets/avatar.jpg",
      comment:
        "I really like the system at this management. I love recommending this software.",
      stars: 5,
    },
    {
      name: "Michael Jonas",
      avatar: "/assets/avatar.jpg",
      comment:
        "This platform saved us a lot of time and the experience is very smooth.",
      stars: 4,
    },
    {
      name: "Ana Silva",
      avatar: "/assets/avatar.jpg",
      comment: "Customer support is excellent and the system works perfectly.",
      stars: 5,
    },
    {
      name: "David Brown",
      avatar: "/assets/avatar.jpg",
      comment: "Very easy to use and extremely efficient for daily operations.",
      stars: 4,
    },
    {
      name: "Sophia Lee",
      avatar: "/assets/avatar.jpg",
      comment: "One of the best tools we’ve used to grow our business.",
      stars: 5,
    },
  ];

  const scrollToIndex = (index) => {
    const container = scrollRef.current;
    const cardWidth = container.children[0].offsetWidth;
    container.scrollTo({
      left: cardWidth * index,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const next = () => {
    const nextIndex = (activeIndex + 1) % totalItems;
    scrollToIndex(nextIndex);
  };

  const prev = () => {
    const prevIndex = activeIndex === 0 ? totalItems - 1 : activeIndex - 1;
    scrollToIndex(prevIndex);
  };

  useEffect(() => {
    intervalRef.current = setInterval(next, 3000);
    return () => clearInterval(intervalRef.current);
  }, [activeIndex]);

  const resetAutoScroll = (cb) => {
    clearInterval(intervalRef.current);
    cb();
  };

  const getStartedBtn = () => {
    const el = document.getElementById("about");
    const headerOffset = 50;

    if (el) {
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div className="heroBackgroundSec">
        <div className="container-fluid maxContainerSection paddingTop">
          <div className="row commonPadding">
            <div className="col-md-6 heroleftSection">
              <h1 className="headingOne m-0">
                MIAXA - nearby stores & local deals
              </h1>
              <p className="m-0 peraGraph">
                Discover nearby stores, local services, and exclusive deals
                around you using MIAXA's smart location-based map.
              </p>
              <div className="heroOuterBtn">
                <button className="howitsWorksBtn" onClick={getStartedBtn}>
                  How it works
                </button>
                <button className="getStartedBtn" onClick={getStartedBtn}>
                  <img src="/assets/RocketLaunch.svg" alt="" />
                  Get started
                </button>
              </div>
            </div>
            <div className="col-md-6 heroBannerImageSection">
              <img src="/assets/heroImage1.svg" alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      <section id="about">
        <div className="commonBgColor">
          <div className="container-fluid maxContainerSection ">
            <div className="row commonPadding">
              <div className="col-md-6 heroImageSection desktopView">
                <img
                  src="/assets/heroImage1.png"
                  alt=""
                  className="img-fluid img1"
                />
                <img
                  src="/assets/heroImage2.png"
                  alt=""
                  className="img-fluid img2"
                />
                <img
                  src="/assets/heroImage3.png"
                  alt=""
                  className="img-fluid img3"
                />
              </div>
              <div className="col-md-6 mobileView heroLeftMobilebView">
                <img src="/assets/heroImage.png" alt="" className="img-fluid" />
              </div>

              <div className="col-md-6 aboutSection">
                <h2 className="m-0 headingTwo">More about miaxa</h2>
                <p className="m-0 peraGraph">
                  Using real-time location data, MIAXA helps you explore nearby
                  shops, services, and exclusive local offers—all in one place.
                  Whether you're searching for something specific or just
                  exploring what's around you, MIAXA brings your local world
                  closer.
                </p>

                <p className="m-0 peraGraph">
                  We're building a smarter way to connect communities with the
                  businesses around them.
                </p>

                <div className="aboutbulletsPointsSection">
                  <div className="aboutbulletsPoints">
                    <img src="/assets/arrowIcon.svg" alt="" />
                    <p className="m-0 peraGraph">
                      MIAXA connects people with nearby businesses through smart
                      location discovery.
                    </p>
                  </div>

                  <div className="aboutbulletsPoints">
                    <img src="/assets/arrowIcon.svg" alt="" />
                    <p className="m-0 peraGraph">
                      Discover local stores, services, and deals—right around
                      you.
                    </p>
                  </div>
                </div>

                <div className="aboutbulletsPoints">
                  <img src="/assets/arrowIcon.svg" alt="" />
                  <p className="m-0 peraGraph">
                    Your local discovery platform.
                  </p>
                </div>

                <div className="downloadAppButton">
                  <Link
                    to="https://apps.apple.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/assets/Apple-button.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </Link>
                  <Link
                    to="https://play.google.com/store/apps/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/assets/Google-button.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid maxContainerSection">
        <div className="row commonPadding">
          <div className="col-md-6 growingNetwork">
            <h2 className="m-0 headingTwo">Our growing network</h2>
            <p className="m-0 peraGraph">
              MIAXA is rapidly growing into a trusted platform for local
              discovery. With thousands of stores across multiple categories and
              a growing user base, we're building a strong connection between
              local businesses and nearby customers. Every download helps
              strengthen local communities and make discovery easier for
              everyone.
            </p>
            <div className="networkDigitOuter">
              <div className="networkDigit">
                <h2 className="m-0 headingTwo">+100</h2>
                <div></div>
                <p className="m-0 peraGraph">Local stores listed</p>
              </div>

              <div className="networkDigit">
                <h2 className="m-0 headingTwo">+200</h2>
                <div></div>
                <p className="m-0 peraGraph">Business categories</p>
              </div>

              <div className="networkDigit">
                <h2 className="m-0 headingTwo">30K</h2>
                <div></div>
                <p className="m-0 peraGraph">App downloads</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 networkImageSection">
            <img src="/assets/Artwork.png" alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="commonBgColor">
        <div className="container-fluid maxContainerSection ">
          <div className="row commonPadding">
            <div className="col-md-12">
              <div className="customerHeaderSection">
                <h2 className="m-0 headingTwo">Our customers review</h2>
                <p className="m-0 peraGraph">
                  Groclone is trusted by fastest growth companies the focus on
                  financial management Here`s what they have to say about us.
                </p>
              </div>

              <div className="commentSectionOuter" ref={scrollRef}>
                {testimonials.map((item, i) => (
                  <div className="commentSection" key={i}>
                    <p className="m-0">{item.comment}</p>

                    <div className="commentUserSectionOuter">
                      <div className="commentUserSection">
                        <img
                          src={item.avatar}
                          alt={item.name}
                          className="commentProfile"
                        />

                        <div>
                          <p className="m-0">{item.name}</p>

                          {[...Array(item.stars)].map((_, s) => (
                            <img key={s} src="/assets/star.svg" alt="star" />
                          ))}
                        </div>
                      </div>

                      <img src="/assets/comma.png" alt="quote" />
                    </div>
                  </div>
                ))}
              </div>

              <div className="comentIndicatorSection">
                <img
                  src="/assets/leftArrow.svg"
                  alt="icon"
                  onClick={() => resetAutoScroll(prev)}
                  style={{ cursor: "pointer" }}
                />

                <div className="dotSection">
                  {[...Array(totalItems)].map((_, i) => (
                    <div
                      key={i}
                      className={`dot ${i === activeIndex ? "dotActive" : ""}`}
                      onClick={() => resetAutoScroll(() => scrollToIndex(i))}
                    />
                  ))}
                </div>

                <img
                  src="/assets/rightArrow.svg"
                  alt="icon"
                  onClick={() => resetAutoScroll(next)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
